import api from ".";
import { IQuestionnaire, IQuestionnaireContent } from "../types/questionnaire";
import cookiesModifier from "../utils/cookies";


export const getAllQuestionnaires = async () => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`questionnaires/all/admin`);

        return res.data as IQuestionnaire[];
    } catch (error) {
        throw error;
    }
}

export const createQuestionnaire = async (data: IQuestionnaire) => {
    try {
        const payload = { name: data.name, quest_code: data.quest_code, version: data.version, description: data.description };

        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.post(`questionnaires`, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateQuestionnaire = async (data: IQuestionnaire) => {
    try {
        const payload = { name: data.name, version: data.version, description: data.description };

        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(`questionnaires/${data.id}`, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const getQuestionnaireContent = async (questCode: string) => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const res = await api.get(`questionnaires/content/${questCode}`);
        return res.data as IQuestionnaireContent;
    } catch (error) {
        throw error;
    }
}

export const duplicateQuestionnaire = async ({ questionnaire, questCode }: { questionnaire: IQuestionnaire, questCode: string }) => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.post(`questionnaires/duplicate/${questCode}`, questionnaire);
        return res.status;
    } catch (error) {
        throw error;
    }
}